export default __webpack_public_path__ + "static/media/Prologue_Kyo2US.56d07cf1.svg";